import { useMemo, useState } from "react"
import type { Dispatch, FC, ReactElement, SetStateAction } from "react"

import * as CronofyElements from "cronofy-elements"
import { useMount, useUnmount, useUpdateEffect } from "react-use"

import { type TCronofyWidgetProps } from "./cronofy-widget.types"

const CronofyWidget: FC<TCronofyWidgetProps> = ({
    options: incomingOptions,
    id: target_id,
    variant,
    wrapperRef,
    wrapperClassName = undefined
}: TCronofyWidgetProps): ReactElement => {
    const [instance, setInstance]: [CronofyElements, Dispatch<SetStateAction<CronofyElements>>] =
        useState<CronofyElements>(null)

    const options: object = useMemo((): object => ({ ...incomingOptions, target_id }), [incomingOptions, target_id])

    useMount((): void => {
        if (!instance) setInstance(CronofyElements[variant]({ ...options, target_id }))
    })

    useUnmount((): void => {
        setInstance(null)
    })

    useUpdateEffect((): void => {
        if (instance) instance.update(options)
    }, [options])

    return <div ref={wrapperRef} id={target_id} {...(wrapperClassName && { className: wrapperClassName })} />
}

CronofyWidget.displayName = "CronofyWidget"

export { CronofyWidget }
